import Address from 'components/Address'
import {
  clearIdentityCheck,
  updateRiskData,
} from 'containers/RiskDataCollectionPage/actions'
import Occupation from 'components/Occupation'
import { useFormikContext } from 'formik'
import { useScheme, useConfusedQuickQuote } from 'hooks'
import React from 'react'
import { useDispatch } from 'react-redux'
import {
  DateOfBirth,
  FirstName,
  LicenceHeldDuration,
  LicenceType,
  ResidencyType,
  Surname,
  Title,
  UKResidencyDuration,
  ReasonForPurchase,
  ReasonForPurchaseOtherText,
} from '../@CommonFields'
import FormField from 'components/@common/FormField'
import ConfusedQuickQuoteOptIn from '../@CommonFields/ConfusedQuickQuoteOptIn'
import { ReasonForPurchaseEnum } from '../@CommonFields/ReasonForPurchase/ReasonForPurchaseEnumeration'
import { PrivateCarFormData } from './PrivateCarForm.types'
import usePrivateCarOccupationExperiment from 'hooks/experiments/usePrivateCarOccupationExperiment'
import { ReasonForPurchaseVariantB } from '../@CommonFields/ReasonForPurchase/ReasonForPurchaseVariantB'
import { useReasonForCoverExperiment } from 'hooks/experiments/ReasonForCoverExperimentConfig'
import { ReasonForPurchaseVariantA } from '../@CommonFields/ReasonForPurchase/ReasonForPurchaseVariantA'

const PrivateCarForm = () => {
  const dispatch = useDispatch()
  const { scheme, isImpounded } = useScheme()
  const { showConfusedQuickQuoteOptIn, validReasonsForPurchase } =
    useConfusedQuickQuote()

  const {
    isOriginal: shouldDisplayReasonForCoverOriginal,
    isVariantA: shouldDisplayReasonForCoverVariantA,
    isVariantB: shouldDisplayReasonForCoverVariantB,
  } = useReasonForCoverExperiment()

  const shouldAskForOccupationForPrivateCar =
    usePrivateCarOccupationExperiment()

  const { values, setFieldValue, errors } =
    useFormikContext<PrivateCarFormData>()

  const {
    dateOfBirth: dateOfBirthValue,
    residencyType: residencyTypeValue,
    licenceType: licenceTypeValue,
    reasonForPurchase: reasonForPurchaseValue,
    reasonForPurchase_VariantA: reasonForPurchaseVariantAValue,
    reasonForPurchase_VariantB: reasonForPurchaseVariantBValue,
  } = values

  const shouldShowReasonForCoverOther = shouldDisplayReasonForCoverOriginal
    ? reasonForPurchaseValue &&
      reasonForPurchaseValue === ReasonForPurchaseEnum.other
    : shouldDisplayReasonForCoverVariantA
    ? reasonForPurchaseVariantAValue === ReasonForPurchaseEnum.other
    : shouldDisplayReasonForCoverVariantB
    ? reasonForPurchaseVariantBValue === ReasonForPurchaseEnum.other
    : false

  // TODO: Revisit this, at the minute we are just
  // reusing logic from before to store descriptions in redux.
  const handleSelect = (name: string, value: string, label: string) => {
    // We need to capitalise first letter, as in state they are using capitals at the start
    const capitalisedName = name.charAt(0).toUpperCase() + name.slice(1)

    switch (capitalisedName) {
      case 'LicenceType':
        dispatch(
          updateRiskData({
            [capitalisedName]: {
              value,
              description: label,
            },
          }),
        )
        return dispatch(clearIdentityCheck())
      case 'ResidencyType':
        if (value === 'PermanentUkResident') {
          setFieldValue('ukResidencyDuration', '')
          return dispatch(
            updateRiskData({
              Expat: false,
              UkResidencyDuration: {
                value: '',
                description: '',
              },
            }),
          )
        }
        return dispatch(
          updateRiskData({
            Expat: true,
          }),
        )

      default:
        return dispatch(
          updateRiskData({
            [capitalisedName]: {
              value,
              description: label,
            },
          }),
        )
    }
  }

  return (
    <>
      <LicenceType onSelect={handleSelect} />
      {(licenceTypeValue !== 'ProvisionalUkLicence' || isImpounded) && (
        <>
          <Title onSelect={handleSelect} />
          <FirstName />
          <Surname />
          {!isImpounded && (
            <>
              <ResidencyType onSelect={handleSelect} />
              {residencyTypeValue &&
                residencyTypeValue !== 'PermanentUkResident' && (
                  <UKResidencyDuration onSelect={handleSelect} />
                )}
            </>
          )}
          <DateOfBirth />
          <Address />
          {shouldAskForOccupationForPrivateCar && (
            <FormField label='Occupation' name='occupation'>
              <Occupation />
            </FormField>
          )}
          {dateOfBirthValue && !errors.dateOfBirth && (
            <LicenceHeldDuration onSelect={handleSelect} />
          )}

          {!isImpounded && (
            <>
              {shouldDisplayReasonForCoverVariantA ? (
                <ReasonForPurchaseVariantA onSelect={handleSelect} />
              ) : null}

              {shouldDisplayReasonForCoverVariantB ? (
                <ReasonForPurchaseVariantB onSelect={handleSelect} />
              ) : null}

              {shouldDisplayReasonForCoverOriginal ? (
                <ReasonForPurchase onSelect={handleSelect} />
              ) : null}

              {shouldShowReasonForCoverOther ? (
                <ReasonForPurchaseOtherText />
              ) : null}
            </>
          )}

          {showConfusedQuickQuoteOptIn &&
            validReasonsForPurchase.includes(reasonForPurchaseValue || '') && (
              <ConfusedQuickQuoteOptIn onSelect={handleSelect} />
            )}
        </>
      )}
    </>
  )
}

export default PrivateCarForm
